import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';

const STATUS_PENDING = 2;

const accountVerifyMixin = {
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('user', ['userData', 'status']),
    ...mapState('wallet', ['balance']),
    accountLink() {
      if (this.isLayoutMobile) return '/account';
      if (this.isWalletEnabled) return '/account/wallet';
      return '/account/details';
    },
    hasUserClassicEnabled() {
      return !this.isLoggedIn || (this.isLoggedIn && this.status.isClassicEnabled !== false);
    },
    isUserVerified() {
      const idVerified = this.userData.idVerified;
      const verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return (typeof idVerified !== 'undefined') ?
          (idVerified || verificationStatus === STATUS_PENDING) :
          true;
    },
    isUserVerifiedFully() {
      const idVerified = this.userData.idVerified;
      const verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return (typeof idVerified !== 'undefined') ?
          (idVerified && verificationStatus !== STATUS_PENDING) :
          true;
    },
    isWalletEnabled() {
      const idVerified = this.userData.idVerified;
      if (!this.isLoggedIn) return true;
      return (typeof idVerified !== 'undefined') ? idVerified : true;
    },
    isUserBalanceEmpty() {
      return this.balance && this.balance.accountBalanceDecimal === 0;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    checkDataIfUserIsVerified(data) {
      if (!this.isLoggedIn) return true;
      return data && (data.idVerified === true || data.verificationStatus === STATUS_PENDING);
    },
    showAccountVerifyPopup() {
      this.setCurrentPopup(MODALS.ACCOUNT_VERIFY);
    },
    showAddFundsPopup() {
      this.setCurrentPopup(MODALS.ADD_FUNDS);
    },
  },
};


export default accountVerifyMixin;



// WEBPACK FOOTER //
// ./src/mixins/accountVerify.js